import React, { useEffect } from "react";

const TermsOfUse = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="terms-of-use-main">
      <div className="terms-of-use-container">
        <div className="container">
          <div className="text-center">
            <h1>Terms of Use</h1>
            <p><strong>Effective Date:</strong> Aug 25th 2025 • <strong>Last Updated:</strong> Aug 25th 2025</p>
          </div>

          <section className="terms-of-use-section">
            <p>
              Welcome to LoveHappiness (the “Service”). The Service is operated by Diamond Star Halo Ltd (“LoveHappiness,” “we,” “us,” or “our”). By downloading, installing, accessing, or using the LoveHappiness mobile application and any related services (the “App” or “Service”), you agree to be bound by these Terms of Use (the “Terms”). If you do not agree to these Terms, do not access or use the Service.
            </p>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">1. Eligibility</h2>
            <ul>
              <li>You must be at least 18 years old to use the Service.</li>
              <li>By using the Service, you represent and warrant that you meet this age requirement and have the authority to enter into these Terms.</li>
              <li>You agree not to use the Service where prohibited by law.</li>
            </ul>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">2. Privacy and Data (UK GDPR)</h2>
            <ul>
              <li>Our Privacy Policy explains how we collect, use, and share information about you. By using the Service, you consent to our data practices described therein.</li>
              <li>
                <strong>Data Controller:</strong> Diamond Star Halo Ltd, 36 Broad Lane, Hale, Cheshire, WA15 0DH, 13803732, registered in England and Wales.
              </li>
              <li>Our processing of personal data is subject to the UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018. We may process personal data based on contract necessity, legal obligation, legitimate interests, or consent.</li>
              <li>
                Your rights: access to your data, rectification, erasure (right to be forgotten), restriction of processing, data portability, objection, and rights related to automated decision-making. To exercise rights, contact us at <a href="mailto:info@lovehappiness.co.uk">info@lovehappiness.co.uk</a>.
              </li>
              <li>Data transfers: if we transfer data outside the UK, we rely on appropriate safeguards (e.g., UK IDTA, SCCs) where required.</li>
              <li>Data retention: we retain personal data for as long as necessary to provide the Service and to comply with legal obligations, typically up to 5 years, after which data is deleted or anonymised.</li>
              <li>Security: we implement appropriate technical and organisational measures to protect personal data.</li>
              <li>Cookies and tracking: details are in our Privacy Policy. By using the Service, you consent to the use of cookies and comparable tracking technologies where applicable.</li>
            </ul>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">3. Accounts and Security</h2>
            <ul>
              <li>You may be required to create an account. You must provide accurate information and keep it up to date.</li>
              <li>You are responsible for maintaining the confidentiality of your password and for restricting access to your device. Notify us immediately of any unauthorised use.</li>
            </ul>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">4. Your Content and Conduct</h2>
            <ul>
              <li>
                You may upload, post, or share content (including messages, photos, and videos) through the Service (“User Content”). You retain ownership of your User Content, but you grant LoveHappiness a worldwide, non-exclusive, royalty-free, sublicensable license to use, reproduce, display, and distribute your User Content as necessary to provide the Service.
              </li>
              <li>You agree not to post or share content that is unlawful, harmful, threatening, abusive, harassing, hateful, defamatory, invasive of privacy, or otherwise objectionable. You may not impersonate others or misrepresent your identity.</li>
              <li>You agree to use the Service in a manner that is respectful and in compliance with all applicable laws.</li>
            </ul>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">5. Prohibited Conduct</h2>
            <ul>
              <li>Non-consensual targeting, harassment, stalking, or intimidation.</li>
              <li>Sharing or soliciting sexually explicit content involving minors or non-consenting individuals.</li>
              <li>Violating third-party rights, including intellectual property rights.</li>
              <li>Uploading malware or engaging in any activity that disrupts or degrades the Service.</li>
              <li>Attempting to circumvent security features or access areas of the Service you are not authorised to use.</li>
            </ul>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">6. Intellectual Property</h2>
            <ul>
              <li>All content and features of the App, including logos, design, branding, and text, are owned by LoveHappiness or its licensors.</li>
              <li>You may use the App and the content solely for your personal, non-commercial use as permitted by these Terms.</li>
              <li>No rights are granted to you except as explicitly stated in these Terms.</li>
            </ul>
          </section>
          <section className="terms-of-use-section" id="eula">
            <h2 className="section-title">7. End User Licence Agreement (EULA)</h2>
            <p>
             Subject to your compliance with these Terms, Diamond Star Halo Ltd (“LoveHappiness”) grants you a limited, non-exclusive, non-transferable, non-sublicensable, revocable licence to download, install, and use the LoveHappiness mobile application on devices that you own or control, solely for your personal, non-commercial use.
            </p>
            <p>Subscription and Payments. The Service offers a subscription plan with a 3-month term that automatically renews for successive 3-month periods at the then-current price unless cancelled. By subscribing, you authorise LoveHappiness (or its third-party payment processors) to charge your chosen payment method on a recurring basis. Prices exclude applicable taxes, which we may collect where required. You consent to these recurring charges and agree we are not liable for any overdraft or insufficient funds fees.</p>
            <p>You may cancel your subscription at any time through your account settings or app store management (e.g., Apple App Store or Google Play). Cancellation takes effect at the end of the current 3-month term; no refunds are provided for partial periods. If you fail to pay any fees, we may suspend or terminate your access without notice.</p>
            <p>This licence does not permit you to:</p>
            <ul>
              <li>Copy, modify, distribute, sell, lease, sublicense, or commercially exploit the App or any part of it;</li>
              <li>Reverse engineer, decompile, or attempt to derive the source code of the App, except where permitted by law;</li>
              <li>Use the App for unlawful, harmful, abusive, or fraudulent purposes;</li>
              <li>Circumvent or attempt to bypass security, moderation, or safety features of the Service.</li>
            </ul>
            <p>All rights not expressly granted to you are reserved by LoveHappiness. This EULA does not transfer any ownership rights in the App or its intellectual property.</p>
            <p>This licence will automatically terminate if you fail to comply with these Terms. Upon termination, you must immediately stop using the App and delete all copies from your devices.</p>
            <p>This EULA is governed by the laws of England and Wales and forms part of these Terms of Use.</p>
          </section>

          <section className="terms-of-use-section">
            <div className="section-title">8. Third-Party Content and Links</div>
            <ul>
              <li>The Service may contain links to third-party websites or services that are not owned or controlled by LoveHappiness.</li>
              <li>We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services.</li>
            </ul>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">9. Disclaimers; Limitation of Liability</h2>
            <ul>
              <li>The Service is provided on an “as is” and “as available” basis.</li>
              <li>LoveHappiness disclaims all warranties, whether express or implied, to the extent permitted by law.</li>
              <li>
                In no event will LoveHappiness be liable for indirect, incidental, special, consequential, or punitive damages.
              </li>
              <li>
                <strong>Limitation of liability:</strong> to the extent permitted by law, LoveHappiness’ aggregate liability arising out of or in connection with these Terms shall not exceed the greater of the amount paid (if any) by you to use the Service in the 12 months preceding the event giving rise to the claim, or £100.
              </li>
            </ul>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">10. Indemnification</h2>
            <p>
              You agree to indemnify, defend, and hold harmless LoveHappiness and its affiliates, officers, employees, and agents from any claims, damages, obligations, losses, liabilities, costs, or debt arising from your use of the Service or your violation of these Terms.
            </p>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">11. Termination</h2>
            <p>
              We may terminate or suspend your access to the Service at our sole discretion, without notice or liability, for any reason including violation of these Terms.
            </p>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">12. Governing Law and Disputes</h2>
            <ul>
              <li>These Terms shall be governed by and construed in accordance with English law.</li>
              <li>Any disputes arising out of or in connection with these Terms shall be resolved exclusively by the courts of England and Wales, subject to mandatory rights of consumers to bring proceedings in their own country under applicable consumer protection law.</li>
              <li>If applicable, we may offer a mediation or arbitration option by agreement.</li>
            </ul>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">13. Changes to Terms</h2>
            <p>
              We may modify these Terms at any time. We will provide notice and, if applicable, obtain your consent where required by law.
            </p>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">14. Notices</h2>
            <p>We may provide notices to you via in-app messages, email, or other reasonable means.</p>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">15. Feedback</h2>
            <p>
              If you provide feedback or suggestions about the Service, you grant us a perpetual, irrevocable, royalty-free license to use and incorporate such feedback.
            </p>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">16. Entire Agreement</h2>
            <p>
              These Terms constitute the entire agreement between you and LoveHappiness regarding the Service and supersede all prior agreements.
            </p>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">17. Severability</h2>
            <p>
              If any provision is deemed invalid or unenforceable, that provision will be limited or eliminated to the minimum extent necessary, and the remaining provisions will remain in full force and effect.
            </p>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">18. Assignment</h2>
            <p>
              You may not assign or transfer your rights or obligations under these Terms without our prior written consent. We may assign or transfer our rights and obligations at our sole discretion.
            </p>
          </section>

          <section className="terms-of-use-section">
            <h2 className="section-title">19. Contact Information</h2>
            <p>
              If you have questions about these Terms, contact us at <a href="mailto:info@lovehappiness.co.uk">info@lovehappiness.co.uk</a> or 36 Broad Lane, Hale, Cheshire, WA15 0DH.
            </p>
          </section>

          {/*
          Privacy Policy link
          • Your Privacy Policy outlines data processing specifics under UK GDPR and data subject rights. Include a prominent link to your Privacy Policy within these Terms.

          Data Processing Addendum (optional)
          • If you engage third-party processors, attach a DPA or include a link to your DPA.

          Notes for customisation
          • Replace all placeholders in brackets with your actual company details.
          • Consider adding a Cookies Policy reference if you use cookies beyond essential cookies.
          • Ensure disclosures about age verification and safety measures reflect your actual features.
          • Have a UK-based solicitor review to ensure compliance with local consumer protection and data protection requirements.
        */}
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
